import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppToast, ToastOptions, ToastType } from './toast.model';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastsSubject = new BehaviorSubject<AppToast[]>([]);
  readonly toasts$ = this.toastsSubject.asObservable();

  success(title: string, options: ToastOptions = {}): string {
    return this.show('success', title, options);
  }

  error(title: string, options: ToastOptions = {}): string {
    return this.show('error', title, options);
  }

  warning(title: string, options: ToastOptions = {}): string {
    return this.show('warning', title, options);
  }

  info(title: string, options: ToastOptions = {}): string {
    return this.show('info', title, options);
  }

  dismiss(id: string): void {
    this.toastsSubject.next(this.toastsSubject.value.filter(toast => toast.id !== id));
  }

  private show(type: ToastType, title: string, options: ToastOptions): string {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const toast: AppToast = {
      id,
      type,
      title,
      message: options.message,
      duration: options.duration ?? 3500,
    };

    // Keep the stack useful and prevent repeated API events filling the screen.
    this.toastsSubject.next([...this.toastsSubject.value.slice(-2), toast]);
    if (toast.duration > 0) window.setTimeout(() => this.dismiss(id), toast.duration);
    return id;
  }
}
